import { UserRole } from '@/core/enums/user-role.enum'

export interface AdminUserEntity {
  id: string
  email: string
  name: string
  role: UserRole
  isActive: boolean
  avatar?: string
  lastLogin?: Date
  createdAt: Date
}

export class AdminUser implements AdminUserEntity {
  constructor(
    public id: string,
    public email: string,
    public name: string,
    public role: UserRole,
    public isActive: boolean,
    public avatar?: string,
    public lastLogin?: Date,
    public createdAt: Date = new Date()
  ) {}

  isSuperAdmin(): boolean {
    return this.role === UserRole.SUPER_ADMIN
  }

  isAdmin(): boolean {
    return [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(this.role)
  }

  canPerform(requiredRole: UserRole): boolean {
    const roleHierarchy = {
      [UserRole.SUPER_ADMIN]: 4,
      [UserRole.ADMIN]: 3,
      [UserRole.MODERATOR]: 2,
      [UserRole.SUPPORT]: 1,
    }
    return roleHierarchy[this.role] >= roleHierarchy[requiredRole]
  }

  getDisplayRole(): string {
    const roleLabels: Record<UserRole, string> = {
      [UserRole.SUPER_ADMIN]: 'Super Admin',
      [UserRole.ADMIN]: 'Admin',
      [UserRole.MODERATOR]: 'Moderator',
      [UserRole.SUPPORT]: 'Support',
    }
    return roleLabels[this.role]
  }
}
